export const STON = 'ston'


export const ADD_URL = '/4e46a4531effd7cdf5e733b964fd408438f4218ab4fd5288e860014e6966d4aa'